import { ROUTER } from '@/shared/config'
import React from 'react'
import { Navigate } from 'react-router-dom'
import { defineEntry, toRoute } from './routeEntry'

const userPages = [
  defineEntry({
    path: ROUTER.CHU_KY_CUA_TOI,
    page: React.lazy(() =>
      import('@/features/user-signature').then((m) => ({ default: m.MySignatureContainer }))
    ),
    menuKey: ROUTER.CHU_KY_CUA_TOI,
  }),
  defineEntry({
    path: ROUTER.VAN_BAN_DA_KY,
    page: React.lazy(() => import('@/features/dossier-signed')),
    menuKey: ROUTER.VAN_BAN_DA_KY,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.MY_DOSSIERS,
    page: React.lazy(() => import('@/features/my-dossiers/pages/MyDossiersPage')),
    menuKey: ROUTER.MY_DOSSIERS,
    skeletonKind: 'table',
  }),
  defineEntry({
    path: ROUTER.MY_DOSSIER_CHI_TIET,
    page: React.lazy(() => import('@/features/my-dossiers/pages/MyDossierDetailPage')),
    menuKey: ROUTER.MY_DOSSIERS,
    skeletonKind: 'detail',
  }),
  defineEntry({
    path: ROUTER.HO_SO_CHI_TIET,
    page: React.lazy(() => import('@/features/dossier-assignment/pages/DossierDetailPage')),
    menuKey: ROUTER.QUAN_LY_HO_SO,
    skeletonKind: 'detail',
  }),
]

export const userRoutes = [
  ...userPages.slice(0, 2).map(toRoute),
  {
    path: '/ho-so-da-ky',
    element: <Navigate to={ROUTER.VAN_BAN_DA_KY} replace />,
  },
  ...userPages.slice(2).map(toRoute),
]
